import { isDefined } from "../../../../_common/checks"
import { TrackingStep } from "../../../../_common/tracking/tracking-step"

const trackingPageNames = [
    // ecommerce
    "guestsV4",
    "categoryV4",
    "fareV4",
    "guests-infoV4",
    "paymentV4",
    "thank-youV4",
    "courtesy-hold-thank-youV4",

    // price config flow
    "send-quoteV4",
    "send-quote-thank-youV4",

    // exit strategy
    "web-quote-formV4",
    "web-quote-thank-youV4",
    "web-quote-exit-intentV4",
] as const

export type TrackingPageV4 = (typeof trackingPageNames)[number]

const step = (number: string, name: string, options?: { pageCat2?: string; flowId?: string }): TrackingStep => ({
    number,
    name,
    pageCat2: options?.pageCat2 ?? name,
    flowId: options?.flowId,
})

const trackingPages: Record<TrackingPageV4, TrackingStep> = {
    // ecommerce
    guestsV4: step("1", "guests"),
    categoryV4: step("2", "category"),
    fareV4: step("3", "fare"),
    "guests-infoV4": step("5", "guests-info"),
    paymentV4: step("6", "payment"),
    "thank-youV4": step("7", "thank-you", { pageCat2: "WBBK TY" }),

    // price config flow
    "send-quoteV4": step("4", "send-quote"),
    "send-quote-thank-youV4": step("TYP", "send-quote-thank-you", { pageCat2: "WEBQ TY" }),

    // web quote exit strategy
    "web-quote-formV4": step("1", "WEBQ", { pageCat2: "web-quote-form" }),
    "web-quote-thank-youV4": step("2", "WEBQ TY"),
    "web-quote-exit-intentV4": step("1", "WEBQ", {
        pageCat2: "web-quote-exit-intent",
    }),

    // courtesy hold in page form
    "courtesy-hold-thank-youV4": step("1", "courtesy-hold-thank-you", { flowId: "b", pageCat2: "WBOF.O4 TY" }),
}

export const isTrackingPageV4 = (page: string): page is TrackingPageV4 =>
    trackingPageNames.includes(page as TrackingPageV4)

export const trackingStepV4 = (activeStep: TrackingPageV4, subStep?: TrackingPageV4): TrackingStep => {
    const active = trackingPages[activeStep]
    if (!subStep) return active

    const sub = trackingPages[subStep]
    const stepNumber = [active.number, sub.flowId, sub.number].filter(isDefined).join(".")

    return {
        name: `${active.name} ${sub.name}`,
        number: stepNumber,
        pageCat2: sub.pageCat2,
    }
}
